import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '../styles';
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '4px -4px',
        '& > *,& > button': {
            flexGrow: 1,
            margin: '4px',
        },
    },
    reverse: {
        flexDirection: 'row-reverse',
    },
}));
function ButtonGroup(props) {
    const classes = useStyles();
    const className = classNames(classes.root, {
        [classes.reverse]: props.reverse,
    });
    return React.createElement("div", { className: className }, props.children);
}
ButtonGroup.propTypes = {
    children: PropTypes.node,
    reverse: PropTypes.bool,
};
export default ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map